import ObservablePropertyDescriptorObject from '../utils/ObservablePropertyDescriptorObject';
import PropertyDescriptor from '../utils/PropertyDescriptor';


export default class Model extends ObservablePropertyDescriptorObject {

    isBusy = new PropertyDescriptor(false, '正在加载', '其他', 'bool', "", {
        enabled: false,
    });

    error = new PropertyDescriptor(null, '错误', "其他", "", "", {
    });

    data = new PropertyDescriptor(null, '数据', "其他", "", "", {
    });

    columns = new PropertyDescriptor(null, '列', "其他", "", "", {
    });

    flag = new PropertyDescriptor(0.0, '加载标识', "其他", "double", "#anticon-profile-setting", {
        enabled: false,
    });

    constructor(opts = {}) {
        super();

        for (var p in opts) {
            this[p].value = opts[p];
        }

        this.defineAllProperties();
    }
}
